import { render, staticRenderFns } from "./SectionItemHover.vue?vue&type=template&id=12b2c783&scoped=true"
import script from "./SectionItemHover.vue?vue&type=script&lang=js"
export * from "./SectionItemHover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b2c783",
  null
  
)

export default component.exports